import React, { useState, useRef, useEffect} from "react";
import { MapContainer, TileLayer, FeatureGroup, useMap } from 'react-leaflet';
import CustomMenuMouse from './Menu/CustomMenuMouse'; 
import DrawingLineHandler from './Drawing/DrawingLineHandler'; 
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import SwapCallsRoundedIcon from '@mui/icons-material/SwapCallsRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import DescriptionIcon from '@mui/icons-material/Description';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Tooltip } from '@mui/material';
import DialogDescriptionComponent from './Dialog/DialogDescriptionComponent/DialogDescriptionComponent'; 
import DrawerMenuEditCanton from './Drawer/DrawerEditCanton/DrawerMenuEditCanton'; 
import DrawerMenuEditSummit from './Drawer/DrawerEditSummit/DrawerMenuEditSummit'; 
import './styleOpticMap.css';
import DrawerMenuViewing from "./Drawer/DrawerViewing/DrawerMenuViewing";
import {icon100pab, icon3k, icon30k, iconSummit, iconKp, iconPillar, iconManhole, iconCoupling,
        iconFob, iconCouplingCanton, iconFobCanton, PILLAR_FLAG, WELL_FLAG, COUPLING_FLAG,
        FOB_FLAG, CONST_HIGHWAY_COUPLING, CONST_CANTON_COUPLING, CONST_HIGHWAY_FOB,
        CONST_CANTON_FOB, CONST_HIGHWAY_PILLAR, CONST_CANTON_PILLAR, CONST_HIGHWAY_MANHOLE,
        CONST_CANTON_MANHOLE, PON_BOX_FLAG, iconPonBox, CONST_CANTON_PON_BOX, PON_BOX,
        WELL, PILLAR,
        ROLE_MASTER,
        ROLE_USER,
        COUPLING,
        FOB,
        iconAmplifier,
        iconOp,
        iconDividerApc,
        iconDividerUpc,
        ROLE_SENIOR_MASTER,
        NODE_PASSIVE_FLAG,
        iconPassiveNode,
        CONST_HIGHWAY_PASSIVE_NODE,
        CONST_CANTON_PASSIVE_NODE,
        PASSIVE_NODE} from './Constants/ConstantsOptics';
import {loadingCanton, loadingRegionsData, loadingAreaData, loadingCity} from './LoadingData/LoadingDataTerritory';       
import {GetHighwayFilter, GetCantonFilter, GetCantonFilterRefresh, GetHighwayFilterRefresh, GetCantonFobFilterRefresh, GetCantonCouplingFilterRefresh, GetCantonWellFilterRefresh, GetCantonPillarFilterRefresh, GetCantonPonBoxFilterRefresh, GetCantonCableFilterRefresh, GetCableByIdFilterRefresh, GetCantonNodeFilterRefresh, GetCantonPassiveNodeFilterRefresh, GetHighwayWellFilterRefresh, GetHighwayPillarFilterRefresh, GetHighwayCouplingFilterRefresh, GetHighwayFobFilterRefresh} from './TerritoryFilter/FilterGetTerritory'      
import CableShowDisplay  from './CableDisplay/CableShowDisplay';
import ModalDeleteComponent from './Modal/ModalDeleteComponent'
import ModalDescriptionComponent from "./Modal/ModalDescriptionComponent";
import ModalSearchComponentMap from "./Modal/ModalSearchComponentMap";
import TerritoryInfo from "./TerritoryFilter/TerritoryInfo";
import ShowLengthCable from "./Drawing/ShowLengthCable";
import ModalEditingCable from "./Drawing/ModalEditingCable";
import GetSwitchesMapLocation from "./TerritoryFilter/GetSwitchesMapLocation";
import MarkersEditing from "./Markers/MarkersEditing";
import MarkersViewing from "./Markers/MarkersViewing";
import MarkersTwoIconViewing from "./Markers/MarkersTwoIconViewing";
import MarkersEditingCoupling from "./Markers/MarkersEditingCoupling";
import MarkersEditingFob from "./Markers/MarkersEditingFob";
import { ROLE_ADMIN, ROLE_ENGINNER } from "./Constants/ConstantsOptics";
import L from 'leaflet';
import ModalLog from "./Modal/ModalLog";
import * as turf from '@turf/turf';
import MarkerPoligonToClick from "./Markers/MarkerPoligonToClick";
import LinkEditingHighway from "./Drawing/LinkEditingHighway";
import LinkEditingCanton from "./Drawing/LinkEditingCanton";
import { CONST_CANTON, CONST_HIGHWAY } from "./Constants/ConstantsOptics";
import MarkersEditingPonBox from "./Markers/MarkersEditingPonBox";
import ShowRuler from "./Drawing/ShowRuler";
import CustomDrawPolyline from "./Components/CustomDrawPolyline";
import ModalRouteCableMap from "./Modal/ModalRouteCableMap";
import MarkersViewingPillar from "./Markers/MarkersViewingPillar";
import MarkersTwoIconViewingCoupling from "./Markers/MarkersTwoIconViewingCoupling";
import MarkersTwoIconViewingFob from "./Markers/MarkersTwoIconViewingFob";
import MarkersViewingPonBox from "./Markers/MarkersViewingPonBox";
import MarkersViewingAmplifier from "./Markers/MarkersViewingAmplifier";
import MarkersViewingOp from "./Markers/MarkersViewingOp";
import ErrorIcon from '@mui/icons-material/Error';
import ModalFasteningErrors from "./Modal/ModalFasteningErrors";
import 'leaflet-geometryutil';
import ModalEditingProblemCable from "./Drawing/ModalEditingProblemCable";
import MarkersViewingProblemCable from "./Markers/MarkersViewingProblemCable";
import MarkersViewingDivider from "./Markers/MarkersViewingDivider";
import MarkerPoligonToClickDistance from "./Markers/MarkerPoligonToClickDistance";
import CustomSnackbar from "./Components/CustomSnackbar";
import { WriteLineOpticCanton } from "./WriteData/WriteCantonCommunications";
import MarkersEditingPassiveNode from "./Markers/MarkersEditingPassiveNode";
import MarkersPassiveNodeViewing from "./Markers/MarkersPassiveNodeViewing";
import { updateWithClosestHouse } from "./Drawing/LinePolygons";

import * as htmlToImage from "html-to-image";
import { jsPDF } from "jspdf";
import { capturePart, exportBigMap, exportBigMapPdf } from "./MapExporter";



const DrawingOpticsMap = (role, user) => {

  const [polylinePoints, setPolylinePoints] = useState([]);
  const[lineId, setLineId] = useState();
  const polylinesRef = useRef({});
  const [lengthCableEditing, setLengthCableEditing] = useState(0);
  const [lengthCableSegment, setLengthCableSegment] = useState(0);
  const [lineEditing, setLineEditing] = useState([]);
  const [selectedRankCouling, setSelectedRankCoupling] = useState(null);
  const [polyline, setPolyline] = useState(null);


  const handlePolylineRef = (id, ref) => {
    polylinesRef.current[id] = ref;
  };

  const[lineMarkerId, setLineMarkerId] = useState();

  //#region ПЕРЕМЕННЫЕ

  //Drawer
  const [openEditCantonDrawer, setOpenEditCantonDrawer] = useState(false);
  const [openEditSummitDrawer, setOpenEditSummitDrawer] = useState(false);
  const [openViewingDrawer, setOpenViewingDrawer] = useState(false);
  const [selectedCanton, setSelectedCanton] = useState([]);
  const [selectedRegoin, setSelectedRegion] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [regions, setRegions] = useState([]);
  const [canton, setCanton] = useState([]);
  const selectedRegionRef = useRef(null);
  const [area, setArea] = useState([]);
  const selectedAreaRef = useRef(null);
  const [selectedCity, setSelectedCity] = useState([]);
  const [city, setCity] = useState([]);
  const [selectCityIsСhange, setSelectCityIsСhange] = useState(null);
  const [selectCantonIsСhange, setSelectCantonIsСhange] = useState(null);
  const [highwayTerritory, setHighwayTerritory] = useState(false);
  const [cantonTerritory, setCantonTerritory] = useState(false);
  const [rulerStatus, setRulerStatus] = useState(false);
  const drawnItemsRef = useRef(new L.FeatureGroup());

  // map
  const mapRef = useRef();
  const polylineHandlerRef = useRef(null);

  // modal
  const [openModal, setOpenModal] = useState(false);
  const [statusModalTerritory, setStatusModalTerritory] = useState('');
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [markerType, setMarkerType] = useState('');
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalRouteCable, setOpenModalRouteCable] = useState(false);
  const [openModalLog, setOpenModalLog] = useState(false);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [openFasteningErrors, setOpenModalFasteningErrors] = useState(false);

  // menu
  const [menuPosition, setMenuPosition] = useState(null);
 
  //poligon
  const [housesData, setHousesData] = useState([]);

  // оборудование
  const [switchesData, setSwitchesData] = useState([]);
  const [showPolygonsArea, setShowPolygonsArea] = useState(false);
  const [showPolygonsCanton, setShowPolygonsCanton] = useState(false);
  const [showHouses, setShowHouses] = useState(false);
  const [showHousesActivatedPassive, setShowHousesActivatedPassive] = useState(false);

  
  
  // cable
  const [selectedLineColor, setSelectedLineColor] = useState();
  const [selectedLineWidth, setSelectedLineWidth] = useState();
  const [coordinatesCableLine, setCoordinatesCableLine] = useState([]);
  const [cableOpticId, setCableOpticId] = useState();
  const [cableTypeId, setCableTypeId] = useState();
  const [cableKind, setCableKind] = useState();
  const [isLineDrawing, setIsLineDrawing] = useState(false);
  const [groupedCoordinatesWithColorTypeAndWidth, setGroupedCoordinatesWithColorTypeAndWidth] = useState({});
  const [descriptionOptic, setDescriptionOptic] = useState({});
  const [showLines, setShowLines] = useState(true);
  const [showLines144, setShowLines144] = useState(true);
  const [showLines96, setShowLines96] = useState(true);
  const [showLines72, setShowLines72] = useState(true);
  const [showLines64, setShowLines64] = useState(true);
  const [showLines48, setShowLines48] = useState(true);
  const [showLines32, setShowLines32] = useState(true);
  const [showLines36, setShowLines36] = useState(true);
  const [showLines24, setShowLines24] = useState(true);
  const [showLines16, setShowLines16] = useState(true);
  const [showLines12, setShowLines12] = useState(true);
  const [showLines8, setShowLines8] = useState(true);
  const [showLines6, setShowLines6] = useState(true);
  const [showLines4, setShowLines4] = useState(true);
  const [showLines2, setShowLines2] = useState(true);
  const [showLines1, setShowLines1] = useState(true);
  const [showPonLayer, setShowPonLayer] = useState(false);
  const [showKtvLayer, setShowKtvLayer] = useState(false);
  const [showEtherLayer, setShowEtherLayer] = useState(false);
  const [showLinesRankSummitToCanton, setShowLinesRankSummitToCanton] = useState(false);
  
  const [showLineDenomination, setShowLinesDenomination] = useState(false);
  const [lengthCable, setLengthCable] = useState(0);
  const [linePoints, setLinePoints] = useState([]);
  const [showLinesTypeSolid, setShowLinesTypeSolid] = useState(true);
  const [showLinesTypeBasement, setShowLinesTypeBasement] = useState(false);
  const [showLinesTypeRoof, setShowLinesTypeRoof] = useState(false);
  const [showLinesTypeLoft, setShowLinesTypeLoft] = useState(false);
  const [showLinesTypeFacade, setShowLinesTypeFacade] = useState(false);
  const [showLinesTypeDashed, setShowLinesTypeDashed] = useState(true);
  const [showAirBetweenHouses, setShowAirBetweenHouses] = useState(false);
  const [showAirPillars, setShowAirPillars] = useState(false);

  const [linkEditing, setLinkEditing] = useState(false);
  const [markerEditing, setMarkerEditing] = useState('');
  const [isComponentСhangeCoor, setIsComponentСhangeCoor] = useState(false);
  const [isComponentСhangeCoorPillar, setIsComponentСhangeCoorPillar] = useState(false);
  const [isComponentСhangeCoorCoupling, setIsComponentСhangeCoorCoupling] = useState(false);
  const [isComponentСhangeCoorFob, setIsComponentСhangeCoorFob] = useState(false);
  const [isComponentСhangeCoorPonBox, setIsComponentСhangeCoorPonBox] = useState(false);
  const [isComponentChangeCoorPassiveNode, setIsComponentChangeCoorPassiveNode] = useState(false);
  
  const [linkEditingProblem, setLinkEditingProblem] = useState(false);
  const[lineProblemId, setLineProblemId] = useState();
  const [markerProblemLineCoordinates, setMarkerProblemLineCoordinates] = useState(null);
  const [flagTettytoryEditingProblemLine, setFlagTettytoryEditingProblemLine] = useState('');
  const linkEditingProblemRef = useRef(linkEditingProblem);
  const [problemCableData, setProblemCableData] = useState([]);

  const [visibleNumberPonBox, setVisibleNumberPonBox] = useState(true);


useEffect(() => {
    linkEditingProblemRef.current = linkEditingProblem;
}, [linkEditingProblem]);


  //marker manhole
  const [markersManhole, setManholeMarkers] = useState([]);
  const [coordinatesManhole, setCoordinatesManhole] = useState([]);
  const [manholeMarker, setIsManholeDrawing] = useState(false);
  const [wellData, setWellData] = useState([]);

  //marker Pillar
  const [markersPillar, setPillarMarkers] = useState([]);
  const [coordinatesPillar, setCoordinatesPillar] = useState([]);
  const [pillarMarker, setIsPillarDrawing] = useState(false);
  const [pillarData, setPillarData] = useState([]);  

  //marker Coupling
  const [markersCoupling, setCouplingMarkers] = useState([]);
  const [coordinatesCoupling, setCoordinatesCoupling] = useState([]);
  const [couplingMarker, setIsCouplingDrawing] = useState(false);
  const [couplingLocationData, setCouplingLocationData] = useState([]);

  //marker Fob
  const [markersFob, setFobMarkers] = useState([]);
  const [coordinatesFob, setCoordinatesFob] = useState([]);
  const [fobMarker, setIsFobDrawing] = useState(false);
  const [fobLocationData, setFobLocationData] = useState([]);
  const [selectedRankFob, setSelectedRankFob] = useState(null);

   //marker PassiveNode
  const [markersPassiveNode, setPassiveNodeMarkers] = useState([]);
  const [coordinatesPassiveNode, setCoordinatesPassiveNode] = useState([]);
  const [passiveNodeMarker, setIsPassiveNodeDrawing] = useState(false);
  const [passiveNodeLocationData, setPassiveNodeLocationData] = useState([]);
 

 //marker PonBox
  const [markersPonBox, setPonBoxMarkers] = useState([]);
  const [coordinatesPonBox, setCoordinatesPonBox] = useState([]);
  const [ponBoxMarker, setIsPonBoxDrawing] = useState(false);
  const [ponBoxLocationData, setPonBoxLocationData] = useState([]);

  // KTV
  const [ktvAmplifierData, setktvAmplifierData] = useState([]);
  const [ktvOpData, setktvOpData] = useState([]);

  // DIVIDER
  const [dividerData, setDividerData] = useState([]);

  // фильтр
  const [loadingSummit, setLoadingSummit] = useState(false);
  const [loadingCunton, setLoadingCunton] = useState(false);
  const [position, setPosition] = useState([0, 0]); 
//#endregion

  //#region ФИЛЬТР
    // фильтр  
    const [layersVisibility, setLayersVisibility] = useState({
      icon100pab: true,
      iconKp: true,
      icon3k: true,
      icon30k: true,
      iconSummit: true,
    });

    const [layersVisibilityCommunications, setLayersVisibilityCommunications] = useState({
      iconPillar: false,
      iconManhole: true,
      iconCoupling: true,
      iconFob: true,
      iconCouplingCanton: true,
      iconPonBox: true,
      iconAmplifier: true,
      iconOp: true,
      iconDividerApc: true,
      iconDividerUpc: true,
      iconPassiveNode: true,
    });
   
    const toggleLayerVisibility = (layer) => {
      setLayersVisibility(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

    const toggleLayerVisibilityCommunications = (layer) => {
      setLayersVisibilityCommunications(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

    const handleNumberPonBoxCheckboxChange = () => {
      setVisibleNumberPonBox(!visibleNumberPonBox); 
    };

    const handleLineCheckboxChange = () => {
      setShowLines(!showLines); 
    };

    const handleLine48CheckboxChange = () => {
      setShowLines48(!showLines48); 
    };

    const handleLine24CheckboxChange = () => {
      setShowLines24(!showLines24); 
    };

    const handleLine12CheckboxChange = () => {
      setShowLines12(!showLines12); 
    };

    const handleLine32CheckboxChange = () => {
      setShowLines32(!showLines32); 
    };

    const handleLine36CheckboxChange = () => {
      setShowLines36(!showLines36); 
    };

    const handleLine64CheckboxChange = () => {
      setShowLines64(!showLines64); 
    };

    const handleLine72CheckboxChange = () => {
      setShowLines72(!showLines72); 
    };

    const handleLine96CheckboxChange = () => {
      setShowLines96(!showLines96); 
    };

     const handleLine144CheckboxChange = () => {
      setShowLines144(!showLines144); 
    }; 

    const handleLine16CheckboxChange = () => {
      setShowLines16(!showLines16); 
    };

    const handleLine8CheckboxChange = () => {
      setShowLines8(!showLines8); 
    };

    const handleLine4CheckboxChange = () => {
      setShowLines4(!showLines4); 
    };

    const handleLine6CheckboxChange = () => {
      setShowLines6(!showLines6); 
    };

    const handleLine2CheckboxChange = () => {
      setShowLines2(!showLines2); 
    };

    const handleLine1CheckboxChange = () => {
      setShowLines1(!showLines1); 
    };

    const handlePonLayerCheckboxChange = () => {
      setShowPonLayer(!showPonLayer); 
      setShowKtvLayer(false);
      setShowEtherLayer(false);
    };

    const handleKtvLayerCheckboxChange = () => {
      setShowKtvLayer(!showKtvLayer); 
      setShowPonLayer(false);
      setShowEtherLayer(false);
    };

    const handleEtherLayerCheckboxChange = () => {
      setShowEtherLayer(!showEtherLayer); 
      setShowKtvLayer(false);
      setShowPonLayer(false);
    };

    const handleLinesDenominationCheckboxChange = () => {
      setShowLinesDenomination(!showLineDenomination); 
    };

    const handleLineTypeSolidCheckboxChange = () => {
      setShowLinesTypeSolid(!showLinesTypeSolid);
      setShowLinesTypeFacade(false);
      setShowLinesTypeLoft(false); 
      setShowLinesTypeBasement(false);
      setShowAirPillars(false);
      setShowAirBetweenHouses(false);
      setShowLinesTypeRoof(false);
    };

    const handleLineTypeDashedCheckboxChange = () => {
      setShowLinesTypeDashed(!showLinesTypeDashed); 
    };

    const handleLineTypeBasementCheckboxChange = () => {
      setShowLinesTypeBasement(!showLinesTypeBasement); 
      setShowLinesTypeFacade(false);
      setShowLinesTypeLoft(false);
      setShowLinesTypeRoof(false);
    };

    const handleLineAirBetweenHousesCheckboxChange = () => {
      setShowAirBetweenHouses(!showAirBetweenHouses); 
      setShowAirPillars(false);
    };

    const handleLineAirPillarsCheckboxChange = () => {
      setShowAirPillars(!showAirPillars); 
      setShowAirBetweenHouses(false);
     
    };

   

    const handleLineTypeFacadeCheckboxChange = () => {
      setShowLinesTypeFacade(!showLinesTypeFacade); 
      setShowLinesTypeBasement(false);
      setShowLinesTypeLoft(false);
      setShowLinesTypeRoof(false);
    };

    const handleLineTypeLoftCheckboxChange = () => {
      setShowLinesTypeLoft(!showLinesTypeLoft); 
      setShowLinesTypeBasement(false);
      setShowLinesTypeFacade(false);
      setShowLinesTypeRoof(false);
    };

     const handleLineTypeRoofCheckboxChange = () => {
      setShowLinesTypeRoof(!showLinesTypeRoof);
      setShowLinesTypeLoft(false); 
      setShowLinesTypeBasement(false);
      setShowLinesTypeFacade(false);
    };


    const handlePoligonCantonChange = () => {
      setShowPolygonsCanton(!showPolygonsCanton); 
    };

    const handlePoligonAreaChange = () => {
      setShowPolygonsArea(!showPolygonsArea); 
    };

    const handleHousesChange = () => {
      setShowHouses(!showHouses); 
    };

    
     const handleHousesActivatedPassiveChange = () => {
      setShowHousesActivatedPassive(!showHousesActivatedPassive); 
    };

    const handleLineRankSummitToCantonCheckboxChange = () => {
      setShowLinesRankSummitToCanton(!showLinesRankSummitToCanton); 
    };

    const changeLinkEditing = (id, status, marker) => {
      setPolylinePoints([]);
      setLineId();
      setMarkerEditing('');
      setLinkEditing(status);  

      if (groupedCoordinatesWithColorTypeAndWidth[id]) {
        setLineId(id);
        setMarkerEditing(marker);
        setPolylinePoints(groupedCoordinatesWithColorTypeAndWidth[id].coordinates);
      }
    };

    // Добавляем проблемное место на карту
    const changeLinkEditingMarker = (id, status, flag) => {
      if (!groupedCoordinatesWithColorTypeAndWidth[id] || !mapRef.current) return;

      setLineProblemId();
      setFlagTettytoryEditingProblemLine('');
      setMarkerProblemLineCoordinates(null);
      setLinkEditingProblem(status);
      //setLinkEditing(status);  
      const map = mapRef.current;
      const lineData = groupedCoordinatesWithColorTypeAndWidth[id];
  
      if (!status || !lineData.coordinates || lineData.coordinates.length < 2) return;
  
      const polyline = L.polyline(lineData.coordinates);
  
      const customIcon = L.icon({
          iconUrl: '/problem.png',
          iconSize: [22, 22],
          iconAnchor: [11, 11],
          popupAnchor: [0, -11]
      });
  
      const handleMapClick = (e) => {
        if (!linkEditingProblemRef.current) return;
         
          const { lat, lng } = e.latlng;
          const closestPoint = L.GeometryUtil.closest(map, polyline, L.latLng(lat, lng));
  
          if (!closestPoint) return;
  
         // Если клик рядом с линией (точность 5м), ставим маркер
        const distance = map.distance([lat, lng], closestPoint);
        if (distance < 5) {
            if (window.currentMarker) {
                // Удаляем старый маркер перед созданием нового
                map.removeLayer(window.currentMarker);
            }

            // Создаем новый маркер и обновляем глобальную переменную
            window.currentMarker = L.marker(closestPoint, { icon: customIcon }).addTo(map);

            setMarkerProblemLineCoordinates({
                lat: closestPoint.lat,
                lng: closestPoint.lng
            });

            setFlagTettytoryEditingProblemLine(flag);
            setLineProblemId(id);              
          }
      };
  
      if (status) {
          map.on('click', handleMapClick);
      } else {
          map.off('click', handleMapClick);
          if (window.currentMarker) {
              map.removeLayer(window.currentMarker);
              window.currentMarker = null;
          }
      }
  };


  useEffect(() => {
      loadingCanton(setCanton); 
      loadingCity(setCity); 
    }, []); 

  
    
    async function handleCantonChange(selectedOption) {
      setSelectCityIsСhange(null);
      setSelectedCanton(selectedOption.value);
      setSelectCantonIsСhange(selectedOption);
      setSelectedRegion(null);
      setSelectedArea(null);
      setHighwayTerritory(false);
      setCantonTerritory(true);
      setShowLinesRankSummitToCanton(false);

      const regionsData = await loadingRegionsData(selectedOption.value);
        if (regionsData) {
            setRegions(regionsData);
        }
  }

    // загрузка веток в селект
    async function handleRegionChange(event) {
      setSelectedRegion(event.target.value);
      const selectedRegion = event.target.value;
      const areaData = await loadingAreaData(selectedRegion);
      if (areaData) {
        setArea(areaData);
      }
    }
    
    async function handleAreaChange(event) {
      setSelectedArea(event.target.value);
    }

    const cantonFobRefresh = () => {
      GetCantonFobFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setFobLocationData, setLoadingCunton, setFobMarkers);
    }; 

    const cantonPassiveNodeRefresh = () => {
      GetCantonPassiveNodeFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setPassiveNodeLocationData, setLoadingCunton, setPassiveNodeMarkers);
    }; 

    const cantonCouplingRefresh = () => {
      GetCantonCouplingFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setCouplingLocationData, setLoadingCunton, setCouplingMarkers);
    }; 

    const cantonWellRefresh = () => {
      GetCantonWellFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setWellData, setLoadingCunton, setManholeMarkers);
    }; 

    const cantonPillarRefresh = () => {
      GetCantonPillarFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setPillarData, setLoadingCunton, setPillarMarkers);
    }; 

    const cantonPonBoxRefresh = () => {
      GetCantonPonBoxFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setLoadingCunton, setPonBoxLocationData, setPonBoxMarkers);
    }; 

    const cantonCablaRefresh = () => {
      GetCantonCableFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton,
         setDescriptionOptic, setLinePoints, setCoordinatesCableLine, handleLineClearMap, setPolylinePoints, setLineEditing, setPolyline,setProblemCableData);
    }; 

     const cantonCablaByIdRefresh = (highwayLineId) => {
           GetCableByIdFilterRefresh( highwayLineId, setGroupedCoordinatesWithColorTypeAndWidth,  setDescriptionOptic,  
                                     groupedCoordinatesWithColorTypeAndWidth, handleLineByIdClearMap);    
     }; 


    const cantonRefresh = () => { 
      GetCantonFilterRefresh( selectedRegoin, selectedArea, selectedCanton, setSwitchesData, setWellData,
              setPillarData, setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth,
              setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setProblemCableData, setDividerData, setktvAmplifierData,
              setPassiveNodeLocationData);     
    };

    const cantonRefreshNode = () => { 
      GetCantonNodeFilterRefresh( selectedRegoin, selectedArea, selectedCanton, setSwitchesData, setFobLocationData,
     setStatusModalTerritory, setPonBoxLocationData, setDividerData, setktvAmplifierData, setGroupedCoordinatesWithColorTypeAndWidth,setProblemCableData, setDescriptionOptic);     
    };

    const handleClickCanton = () => {      
          GetCantonFilter( selectedRegionRef, selectedAreaRef, selectedCanton, setSwitchesData, setWellData,
               setPillarData, setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth,
               setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setHousesData,
               setktvAmplifierData, setktvOpData, setProblemCableData, setDividerData, setPassiveNodeLocationData); 
    };

    const handleClickSummit = () => {
     GetHighwayFilter( setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,setPonBoxLocationData,
                     setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition,setStatusModalTerritory,setDescriptionOptic,setProblemCableData); 
    };

    const highwayRefresh = () => {
      GetHighwayFilterRefresh( setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
                      setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition,setStatusModalTerritory,setDescriptionOptic,setProblemCableData, handleLineClearMap); 
     };

    const highwayWellRefresh = () => {
       GetHighwayWellFilterRefresh(selectedCity, setWellData, setLoadingSummit, setManholeMarkers);
    }; 

    const highwayPillarRefresh = () => {
       GetHighwayPillarFilterRefresh(selectedCity, setPillarData, setLoadingSummit, setPillarMarkers);
    }; 

    const highwayCouplingRefresh = () => {
       GetHighwayCouplingFilterRefresh(selectedCity, setCouplingLocationData, setLoadingSummit, setCouplingMarkers);
    }; 

     const highwayFobRefresh = () => {
       GetHighwayFobFilterRefresh(selectedCity, setFobLocationData, setLoadingSummit, setFobMarkers);
    }; 

     async function handleCityChange(selectedOption) {
      setSelectCantonIsСhange(null);
      setSelectedRegion(null);
      setSelectedArea(null);
      setSelectedCity(selectedOption.value);  
      setSelectCityIsСhange(selectedOption);  
      setCantonTerritory(false);
      setHighwayTerritory(true);
      setShowLinesRankSummitToCanton(true);
    }
 
    // Обновление центра карты
    useEffect(() => {
      if (position[0] !== 0 || position[1] !== 0) {
        mapRef.current?.setView(position, 14);//13
      }
    }, [position]);
//#endregion
    
  //#region DRAWER
  const toggleViewingDrawer = (isOpen) => () => {
    setOpenViewingDrawer(isOpen);
  }; 

  const toggleEditCantonDrawer = (cantonTerritory, isOpen) => () => {
    if(!cantonTerritory == false && (role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER)){
       setOpenEditCantonDrawer(isOpen);
    }else{
       setOpenEditCantonDrawer(false);
    }
  }; 

  const toggleEditSummitDrawer = (highwayTerritory, isOpen) => () => {
    if(!highwayTerritory == false && (role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN)){
      setShowLinesRankSummitToCanton(true);
      setOpenEditSummitDrawer(isOpen);
    }else{
      setOpenEditSummitDrawer(false);
    }
  };  
//#endregion

  //#region MODAL
  const openModalWithContent = (content, markerType) => {
    setModalContent(content);
    setMarkerType(markerType);
    setOpenModal(true);
   
  };

  // const openModalDeleteComponents = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN){
  //     setOpenModalDelete(true);
  //   }else{
  //     setOpenModalDelete(false);
  //   }
   
  // };
  
  const openModalDescriptionComponents = () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER || role.role == ROLE_SENIOR_MASTER){
      setOpenModalDescription(true);
    }else{
      setOpenModalDescription(false);
    }
  }; 

  const openModalRouteOptic = () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER || role.role == ROLE_SENIOR_MASTER){
      setOpenModalRouteCable(true);
    }else{
      setOpenModalRouteCable(false);
    }
  }; 

  const openModalSearchComponents = () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER || role.role == ROLE_SENIOR_MASTER){
      setOpenModalSearch(true);
    }else{
      setOpenModalSearch(false);
    }
  };

  const openModalFasteningErrors = () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_SENIOR_MASTER){
      setOpenModalFasteningErrors(true);
    }else{
      setOpenModalFasteningErrors(false);
    }
  };

  const toggleModalLog = (isOpen) => () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_USER || role.role == ROLE_SENIOR_MASTER){
       setOpenModalLog(isOpen);
    }else{
      setOpenModalLog(false);
    }
  }; 

  const handleEditingCancelClick = () => {
    setLineEditing([]);
    setPolylinePoints([]);  
    setLineId();
    setPolylinePoints([]);
    setLinkEditing(false);
  };

  const handleEditingProblemLineCancelClick = () => {
    setLinkEditingProblem(false);
    setMarkerProblemLineCoordinates(null);  
    setFlagTettytoryEditingProblemLine('');
    setLineProblemId();
  };



  const toggleRuler = (isOpen) => () => {
    if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER || role.role == ROLE_SENIOR_MASTER){
       setRulerStatus(isOpen);
    }else{
      setRulerStatus(false);
    }
  }; 
//#endregion

  //#region MENU
  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuPosition({ top: event.pageY, left: event.pageX });
  };

  const handleClose = () => {
    setMenuPosition(null);
  };
  //#endregion

  //#region РИСОВАНИЕ
    const handleStartDrawing = () => {
      setIsLineDrawing(true);
    };












    const handleStopDrawing = () => {
        setIsLineDrawing(false);
        const updated = updateWithClosestHouse(coordinatesCableLine, housesData, 6);
        setCoordinatesCableLine(updated); // обновим точки
    };
    
    

  //   const handleStopDrawing = () => {    
  //       setIsLineDrawing(false);

  //         // Проверяем, что функция handleCableSave передана и вызываем её
  //   if (handleCableSaveRef) {
  //     handleCableSaveRef();
  // }
  //   };

    // const handleStopDrawing = () => {
     
    //   setIsLineDrawing(false);
    //   if (handleCableSaveRef.current) {
    //     handleCableSaveRef.current(); // Вызываем метод сохранения
    //   }
    // };
   
  //#endregion

  //#region КАБЕЛЬ

  //кабель
  const removeLastPoint = () => {
    setLinePoints((prevPoints) => {
      const newPoints = prevPoints.slice(0, -1);
      updateLength(newPoints);
      return newPoints;
    });
  
    setCoordinatesCableLine((prevCoordinates) => {
      if (prevCoordinates && prevCoordinates.length > 0) {
        const newCoordinates = prevCoordinates.slice(0, -1);
        return newCoordinates;
      }
      return prevCoordinates;
    });
  };

  useEffect(() => {    
    if (linePoints.length < coordinatesCableLine.length) {
      setCoordinatesCableLine((prevCoordinates) => {
        const newCoordinates = prevCoordinates.slice(0, -1);
        return newCoordinates;
      });
    }
  }, [linePoints]); 

  const updateLength = (points) => {
    let totalLength = 0; 

    for (let i = 0; i < points.length - 1; i++) {
      const point1 = L.latLng(points[i]);
      const point2 = L.latLng(points[i + 1]);
      totalLength += point1.distanceTo(point2);
    }
    setLengthCable(totalLength.toFixed(2));
  };


  // const handleCableSelectChange = (event) => {
  //   const selectedColor = event.target.value;
  //   const [id,color, width, name, fiberQuantity] = selectedColor.split(',');
  //   setCableOpticId(id);
  //   setSelectedLineColor(color);
  //   setSelectedLineWidth(width);
  // };

  const handleCableSelectChange = (selectedOption) => {
    if (selectedOption === null) {
      // Если пользователь очистил выбор
      setCableOpticId(null);
      setSelectedLineColor(null);
      setSelectedLineWidth(null);
      return;
    }
  
    const [id, color, width, name, fiberQuantity] = selectedOption.value.split(',');
    setCableOpticId(id);
    setSelectedLineColor(color);
    setSelectedLineWidth(width);
  };

  // const handleLineStyleSelectChange = (event) => {
  //   const selectedLineStyle = event.target.value;
  //   const [id, type,kind] = selectedLineStyle.split(','); 
  //   setCableTypeId(id);
  //   setCableKind(kind);  
  // };
  const handleLineStyleSelectChange = (event) => {
    const selectedValue = event.target.value;
    parseCableTypeValue(selectedValue);
  };

  const parseCableTypeValue = (value) => {
  if (!value) {
    setCableTypeId();
    setCableKind();
    return;
  }
  const [id, type, kind] = value.split(',');
  setCableTypeId(id);
  setCableKind(kind);
};
  //#endregion
  
 //#region КОЛОДЕЦ

  //marker колодец

  const toggleManholeMarker = () => {
    setIsManholeDrawing(!manholeMarker);     
  };

  const removeManholeMarker = (index) => {  
    const newManholeMarkers = markersManhole.filter((marker, idx) => idx !== index);
    const newManholeCoordinates = coordinatesManhole.filter((coordinate, idx) => idx !== index);
    setManholeMarkers(newManholeMarkers);
    setCoordinatesManhole(newManholeCoordinates);
  };
//#endregion

//#region ОПОРА

  const togglePillarMarker = () => {
    setIsPillarDrawing(!pillarMarker);
  };

  const removePillarMarker = (index) => {
      const newPillarMarkers = markersPillar.filter((marker, idx) => idx !== index);
      const newPillarCoordinates = coordinatesPillar.filter((coordinate, idx) => idx !== index);
      setPillarMarkers(newPillarMarkers);
      setCoordinatesPillar(newPillarCoordinates);    
  };
//#endregion

 //#region МУФТА

  const toggleCouplingMarker = () => {
    setIsCouplingDrawing(!couplingMarker);
  };

  const removeCouplingMarker = (index) => {  
      const newCouplingMarkers = markersCoupling.filter((marker, idx) => idx !== index);
      const newCouplingCoordinates = coordinatesCoupling.filter((coordinate, idx) => idx !== index);
      setCouplingMarkers(newCouplingMarkers);
      setCoordinatesCoupling(newCouplingCoordinates);

      
  };
//#endregion

//#region ФОБ

  const toggleFobMarker = () => {
    setIsFobDrawing(!fobMarker);
  };

  const removeFobMarker = (index) => {
      const newFobMarkers = markersFob.filter((marker, idx) => idx !== index);
      const newFobCoordinates = coordinatesFob.filter((coordinate, idx) => idx !== index);
      setFobMarkers(newFobMarkers);
      setCoordinatesFob(newFobCoordinates);    
  }; 
 //#endregion

 //#region Узел

  const togglePassiveNodeMarker = () => {
    setIsPassiveNodeDrawing(!passiveNodeMarker);
  };

  const removePassiveNodeMarker = (index) => {
      const newPassiveNodeMarkers = markersPassiveNode.filter((marker, idx) => idx !== index);
      const newPassiveNodeCoordinates = coordinatesPassiveNode.filter((coordinate, idx) => idx !== index);
      setPassiveNodeMarkers(newPassiveNodeMarkers);
      setCoordinatesPassiveNode(newPassiveNodeCoordinates);    
  }; 
   //#endregion

 //#region Pon-box

 const togglePonBoxMarker = () => {
  setIsPonBoxDrawing(!ponBoxMarker);
};

const removePonBoxMarker = (index) => {
    const newPonBoxMarkers = markersPonBox.filter((marker, idx) => idx !== index);
    const newPonBoxCoordinates = coordinatesPonBox.filter((coordinate, idx) => idx !== index);
    setPonBoxMarkers(newPonBoxMarkers);
    setCoordinatesPonBox(newPonBoxCoordinates);    
}; 
//#endregion

 

 const handleChangeRankComponentCoupling = (event) => {
  const selectedRankComponent = event.target.value;
  setSelectedRankCoupling(selectedRankComponent);
};



const handleChangeRankComponentFob = (event) => {
 const selectedRankComponent = event.target.value;
 setSelectedRankFob(selectedRankComponent);
};



const enableRuler = () => {
  if (mapRef.current) {
    const map = mapRef.current;

    if (polylineHandlerRef.current) {
      return; 
    }

    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }

  
    const polylineHandler = new CustomDrawPolyline(map, {
      shapeOptions: {
        color: '#172c85',
        weight: 4
      }
    });

   
    polylineHandlerRef.current = polylineHandler;
    polylineHandler.enable();

    
    map.on('draw:created', (e) => {
      const layer = e.layer;
      if (layer instanceof L.Polyline) {
        drawnItemsRef.current.addLayer(layer); 
      }

      if (polylineHandlerRef.current) {
        polylineHandlerRef.current.disable(); 
        polylineHandlerRef.current = null; 
      }
    });
  }
};




const resetRuler = () => {
  if (drawnItemsRef.current) {
    drawnItemsRef.current.clearLayers(); 
  }

  if (polylineHandlerRef.current) {
    polylineHandlerRef.current.disable(); 
    polylineHandlerRef.current = null; 
  }
};

useEffect(() => {
  if (mapRef.current) {
    const map = mapRef.current;
    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }
  }
}, []);

// очищаем карту
const handleClearMap2 = () => {
  const map = mapRef.current; // Получаем объект карты
  if (map) {
    // Удаляем все пользовательские слои
    map.eachLayer((layer) => {
      if (!(layer instanceof L.TileLayer)) {
        map.removeLayer(layer);
      }
    });
  }
};

const handleLineClearMap = async () => {
   setGroupedCoordinatesWithColorTypeAndWidth([]);
      setDescriptionOptic({});
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);
};

const handleLineByIdClearMap = async () => {
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);
};





// экспорт карты в пдф
// const exportCurrentView = async () => {
//     await exportBigMapPdf(mapRef.current, 8, 8);
// };

  return (
    
    <div className="divMainOptic" >

      <div style={{ display: 'flex', height: '100vh' }} onContextMenu={handleContextMenu} >
        <div style={{ flexGrow: 0, display: 'flex', flexDirection: 'column' }}>

          <Tooltip title="Просмотр" arrow>
            <IconButton onClick={toggleViewingDrawer(true)}>
              <VisibilityRoundedIcon />
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Режим внесения РАНГ 1 / 2" arrow>
            <IconButton onClick={toggleEditSummitDrawer(highwayTerritory, true)}>
                <SettingsInputCompositeIcon/>
            </IconButton>
          </Tooltip>

          <Tooltip title="Режим внесения ОКРУГ / РЕГИОН / ВЕТКА" arrow>
            <IconButton onClick={toggleEditCantonDrawer(cantonTerritory, true)}>
              <SwapCallsRoundedIcon />
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Детально" arrow>
            <IconButton onClick={openModalDescriptionComponents}>
              <DescriptionIcon/>
            </IconButton>
          </Tooltip>

          <Tooltip title="Маршрут" arrow>
            <IconButton onClick={openModalRouteOptic}>
              <AltRouteIcon/>
            </IconButton>
          </Tooltip>

          <Tooltip title="Поиск" arrow>
            <IconButton onClick={openModalSearchComponents}>
              <SearchIcon/>
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Логи" arrow>
            <IconButton onClick={toggleModalLog(true)}>
              <FormatListNumberedIcon/>
            </IconButton>
          </Tooltip>

          <Tooltip title="Линейка" arrow>
            <IconButton onClick={toggleRuler(true)}>
              <SquareFootIcon/>
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Закрепление" arrow>
            <IconButton onClick={openModalFasteningErrors}>
              <ErrorIcon/>
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          {/* <Tooltip title="Удаление по ID" arrow>
            <IconButton onClick={openModalDeleteComponents}>
              <DeleteIcon/>
            </IconButton>
          </Tooltip> */}
          {/* <button onClick={exportCurrentView}>
    PDF
</button> */}
        </div>
        <DrawerMenuEditCanton
          openEditCantonDrawer={openEditCantonDrawer}
          toggleEditCantonDrawer={toggleEditCantonDrawer}
          handleCableSelectChange={handleCableSelectChange}
          handleLineStyleSelectChange={handleLineStyleSelectChange}
          isLineDrawing={isLineDrawing}
          handleStartDrawing={handleStartDrawing}
          handleStopDrawing={handleStopDrawing}
          toggleManholeMarker={toggleManholeMarker}
          manholeMarker={manholeMarker}
          togglePillarMarker={togglePillarMarker}
          pillarMarker={pillarMarker}
          toggleCouplingMarker={toggleCouplingMarker}
          couplingMarker={couplingMarker}
          toggleFobMarker={toggleFobMarker}
          fobMarker={fobMarker}
          coordinatesManhole={coordinatesManhole}
          setCoordinatesManhole={setCoordinatesManhole}
          coordinatesPillar={coordinatesPillar}
          setCoordinatesPillar={setCoordinatesPillar}
          coordinatesCoupling={coordinatesCoupling}
          setCoordinatesCoupling={setCoordinatesCoupling}
          coordinatesFob={coordinatesFob}
          setCoordinatesFob={setCoordinatesFob}
          coordinatesCableLine={coordinatesCableLine}
          setCoordinatesCableLine={setCoordinatesCableLine}         
          cableOpticId={cableOpticId}
          cableTypeId={cableTypeId}
          cantonRefresh={cantonRefresh}
          setLengthCable={setLengthCable}
          lengthCable={lengthCable}
          selectedRankCouling={selectedRankCouling}
          setSelectedRankCoupling={setSelectedRankCoupling}
          handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
          selectedRankFob={selectedRankFob}
          setSelectedRankFob={setSelectedRankFob}
          handleChangeRankComponentFob={handleChangeRankComponentFob}
          user={role.user}
          selectedCity={selectedCity}
          highwayTerritory={highwayTerritory}
          togglePonBoxMarker={togglePonBoxMarker}
          ponBoxMarker={ponBoxMarker}
          coordinatesPonBox={coordinatesPonBox}
          setCoordinatesPonBox={setCoordinatesPonBox}
          cantonFobRefresh={cantonFobRefresh}
          cantonCouplingRefresh={cantonCouplingRefresh}
          cantonWellRefresh={cantonWellRefresh}
          cantonPillarRefresh={cantonPillarRefresh}
          cantonPonBoxRefresh={cantonPonBoxRefresh}
          cantonCablaRefresh={cantonCablaRefresh}
          selectedCanton={selectedCanton}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          role={role}
          cantonCablaByIdRefresh={cantonCablaByIdRefresh}
          togglePassiveNodeMarker={togglePassiveNodeMarker}
          passiveNodeMarker={passiveNodeMarker}
          coordinatesPassiveNode={coordinatesPassiveNode}
          setCoordinatesPassiveNode={setCoordinatesPassiveNode}
          cantonPassiveNodeRefresh={cantonPassiveNodeRefresh}
          
        />
       

        <DrawerMenuEditSummit
          openEditSummitDrawer={openEditSummitDrawer}
          toggleEditSummitDrawer={toggleEditSummitDrawer}
          handleCableSelectChange={handleCableSelectChange}
          handleLineStyleSelectChange={handleLineStyleSelectChange}
          isLineDrawing={isLineDrawing}
          handleStartDrawing={handleStartDrawing}
          handleStopDrawing={handleStopDrawing}
          toggleManholeMarker={toggleManholeMarker}
          manholeMarker={manholeMarker}
          togglePillarMarker={togglePillarMarker}
          pillarMarker={pillarMarker}
          toggleCouplingMarker={toggleCouplingMarker}
          couplingMarker={couplingMarker}
          toggleFobMarker={toggleFobMarker}
          fobMarker={fobMarker}
          coordinatesManhole={coordinatesManhole}
          setCoordinatesManhole={setCoordinatesManhole}
          coordinatesPillar={coordinatesPillar}
          setCoordinatesPillar={setCoordinatesPillar}
          coordinatesCoupling={coordinatesCoupling}
          setCoordinatesCoupling={setCoordinatesCoupling}
          coordinatesFob={coordinatesFob}
          setCoordinatesFob={setCoordinatesFob}
          coordinatesCableLine={coordinatesCableLine}
          setCoordinatesCableLine={setCoordinatesCableLine}         
          cableOpticId={cableOpticId}
          cableTypeId={cableTypeId}
          highwayRefresh={highwayRefresh}
          setLengthCable={setLengthCable}
          lengthCable={lengthCable}
          user={role.user}
          handleChangeRankComponentFob={handleChangeRankComponentFob}
          setSelectedRankFob={setSelectedRankFob}
          selectedRankFob={selectedRankFob}
          selectedRankCouling={selectedRankCouling}
          setSelectedRankCoupling={setSelectedRankCoupling}
          handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
          selectedCity={selectedCity}
          highwayTerritory={highwayTerritory}
          selectedCanton={selectedCanton}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          cantonCablaByIdRefresh={cantonCablaByIdRefresh}
          highwayWellRefresh={highwayWellRefresh}
          highwayPillarRefresh={highwayPillarRefresh}
          highwayCouplingRefresh={highwayCouplingRefresh}
          highwayFobRefresh={highwayFobRefresh}
          role={role}
        />

        <DrawerMenuViewing
          openViewingDrawer={openViewingDrawer}
          toggleViewingDrawer={toggleViewingDrawer}
          loadingSummit={loadingSummit}
          loadingCunton={loadingCunton}
          toggleLayerVisibility={toggleLayerVisibility}
          layersVisibility={layersVisibility}
          canton={canton}
          handleCantonChange={handleCantonChange}
          handleRegionChange={handleRegionChange}
          selectedRegionRef={selectedRegionRef}
          regions={regions}
          selectedAreaRef={selectedAreaRef}
          area={area}
          handleClickCanton={handleClickCanton}
          layersVisibilityCommunications={layersVisibilityCommunications}
          toggleLayerVisibilityCommunications={toggleLayerVisibilityCommunications}
          handleLineCheckboxChange={handleLineCheckboxChange}
          showLines={showLines} 
          city={city}
          handleCityChange={handleCityChange} 
          handleClickSummit={handleClickSummit}
          handleAreaChange={handleAreaChange}
          handleLine48CheckboxChange={handleLine48CheckboxChange}
          showLines48={showLines48}
          handleLine24CheckboxChange={handleLine24CheckboxChange}
          showLines24={showLines24}
          handleLine12CheckboxChange={handleLine12CheckboxChange}
          showLines12={showLines12}
          handleLine8CheckboxChange={handleLine8CheckboxChange}
          showLines8={showLines8}
          handleLine4CheckboxChange={handleLine4CheckboxChange}
          showLines4={showLines4}
          handleLine2CheckboxChange={handleLine2CheckboxChange}
          showLines2={showLines2}
          handleLine1CheckboxChange={handleLine1CheckboxChange}
          showLines1={showLines1}
          handleLine16CheckboxChange={handleLine16CheckboxChange}
          showLines16={showLines16}
          handleLine32CheckboxChange={handleLine32CheckboxChange}
          showLines32={showLines32}
          handleLine36CheckboxChange={handleLine36CheckboxChange}
          showLines36={showLines36}
          handleLine64CheckboxChange={handleLine64CheckboxChange}
          showLines64={showLines64}
          handleLine72CheckboxChange={handleLine72CheckboxChange}
          showLines72={showLines72}
          handleLine96CheckboxChange={handleLine96CheckboxChange}
          showLines96={showLines96}
          handleLine144CheckboxChange={handleLine144CheckboxChange}
          showLines144={showLines144}
          handlePonLayerCheckboxChange={handlePonLayerCheckboxChange}
          showPonLayer={showPonLayer}
          handleLinesDenominationCheckboxChange={handleLinesDenominationCheckboxChange}
          showLineDenomination={showLineDenomination}
          selectCityIsСhange={selectCityIsСhange}
          selectCantonIsСhange={selectCantonIsСhange}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          showLinesTypeSolid={showLinesTypeSolid}
          showLinesTypeDashed={showLinesTypeDashed}
          handleLineTypeSolidCheckboxChange={handleLineTypeSolidCheckboxChange}
          handleLineTypeDashedCheckboxChange={handleLineTypeDashedCheckboxChange}
          handlePoligonCantonChange={handlePoligonCantonChange}
          showPolygonsCanton={showPolygonsCanton}
          handlePoligonAreaChange={handlePoligonAreaChange}
          showPolygonsArea={showPolygonsArea}
          handleKtvLayerCheckboxChange={handleKtvLayerCheckboxChange}
          showKtvLayer={showKtvLayer}
          handleEtherLayerCheckboxChange={handleEtherLayerCheckboxChange}
          showEtherLayer={showEtherLayer}
          handleLineTypeBasementCheckboxChange={handleLineTypeBasementCheckboxChange}
          showLinesTypeBasement={showLinesTypeBasement}
          handleLineTypeFacadeCheckboxChange={handleLineTypeFacadeCheckboxChange}
          showLinesTypeFacade={showLinesTypeFacade}
          handleLineTypeLoftCheckboxChange={handleLineTypeLoftCheckboxChange}
          showLinesTypeLoft={showLinesTypeLoft}
          handleLineTypeRoofCheckboxChange={handleLineTypeRoofCheckboxChange}
          showLinesTypeRoof={showLinesTypeRoof}
          handleHousesChange={handleHousesChange}
          showHouses={showHouses}
          handleNumberPonBoxCheckboxChange={handleNumberPonBoxCheckboxChange}
          visibleNumberPonBox={visibleNumberPonBox}
          handleLineRankSummitToCantonCheckboxChange={handleLineRankSummitToCantonCheckboxChange}
          showLinesRankSummitToCanton={showLinesRankSummitToCanton}
          highwayTerritory={highwayTerritory}
          handleLineAirBetweenHousesCheckboxChange={handleLineAirBetweenHousesCheckboxChange}
          showAirBetweenHouses={showAirBetweenHouses}
          handleLineAirPillarsCheckboxChange={handleLineAirPillarsCheckboxChange}
          showAirPillars={showAirPillars}
          handleHousesActivatedPassiveChange={handleHousesActivatedPassiveChange}
          showHousesActivatedPassive={showHousesActivatedPassive}
          handleLine6CheckboxChange={handleLine6CheckboxChange}
          showLines6={showLines6}
        />
        
        {/* menu на мышку */}
        <CustomMenuMouse 
          menuPosition={menuPosition}
          handleClose={handleClose} 
          handleStopDrawing={handleStopDrawing}
          open={Boolean(menuPosition)} 
          isLineDrawing={isLineDrawing}
          removeLastPoint={removeLastPoint}
        />

      {/* div отображение выбранной территории */}
      <TerritoryInfo
        highwayTerritory={highwayTerritory}
        cantonTerritory={cantonTerritory}
        selectedCity={selectedCity}
        selectedCanton={selectedCanton}
        selectedRegion={selectedRegoin}
        selectedArea={selectedArea}
        handleEditingCancelClick={handleEditingCancelClick}
      />

    {/* отображение длинны кабеля при рисовании */}
    <ShowLengthCable
        isLineDrawing={isLineDrawing}
        lengthCable={lengthCable}
        lengthCableSegment={lengthCableSegment}
    />

     {/* отображение линейки */}
     <ShowRuler
        rulerStatus={rulerStatus}
        setRulerStatus={setRulerStatus}
        enableRuler={enableRuler}
        resetRuler={resetRuler}
      />

     {/* отображение длинны кабеля при редактировании */}
     <ModalEditingCable
        isEditing={linkEditing} 
        setLinkEditing={setLinkEditing}
        setPolylinePoints={setPolylinePoints}  
        lineEditing={lineEditing}
        lengthCableEditing={lengthCableEditing}
        lineId={lineId}
        user={role.user}
        setLineId={setLineId}
        highwayRefresh={cantonCablaByIdRefresh}
        setLineEditing={setLineEditing}
        markerEditing={markerEditing}
        cantonRefresh={cantonCablaByIdRefresh}
        handleEditingCancelClick={handleEditingCancelClick}
        housesData={housesData}
    />

       {/* отображение окна для проблемного места на кабеле */}
       <ModalEditingProblemCable
        isEditing={linkEditingProblem} 
        setLinkEditingProblem={setLinkEditingProblem}
        markerProblemLineCoordinates={markerProblemLineCoordinates}
        setMarkerProblemLineCoordinates={setMarkerProblemLineCoordinates}
        lineId={lineProblemId}
        user={role.user}           
        handleEditingCancelClick={handleEditingProblemLineCancelClick}
        setLinkEditing={setLinkEditing}
        cantonCablaRefresh={cantonCablaRefresh}
        mapRef={mapRef}
        statusModalTerritory={statusModalTerritory}
        highwayRefresh={highwayRefresh}
    />

<MapContainer
  center={[48.749, 31.267]}
  zoom={6}
  minZoom={6}
  style={{ flex: '1', borderRadius: '10px' }}
  ref={mapRef}
  whenCreated={(mapInstance) => { mapRef.current = mapInstance; }}
>

<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  maxZoom={19.5} 
/>

         {/* рисуем оборудку */}       
         <GetSwitchesMapLocation
          switchesData={switchesData}
          layersVisibility={layersVisibility}
          isLineDrawing={isLineDrawing}
          icon100pab={icon100pab}
          iconKp={iconKp}
          icon3k={icon3k}
          icon30k={icon30k}
          iconSummit={iconSummit}
          mapRef={mapRef}
          highwayTerritory={highwayTerritory}
          cantonTerritory={cantonTerritory}
          showPolygonsCanton={showPolygonsCanton}
          showPolygonsArea={showPolygonsArea}  
          fobMarker={fobMarker}  
          ponBoxMarker={ponBoxMarker}
          pillarMarker={pillarMarker}
          manholeMarker={manholeMarker}
          couplingMarker={couplingMarker}
          housesData={housesData}
          user={role.user}
          cantonRefresh={cantonRefresh}
          role={role}
          showPonLayer={showPonLayer}
          showKtvLayer={showKtvLayer}
          showHouses={showHouses}
          cantonFobRefresh={cantonFobRefresh}
          cantonPonBoxRefresh={cantonPonBoxRefresh}
          highwayRefresh={highwayRefresh}
          ktvAmplifierData={ktvAmplifierData}
          cantonRefreshNode={cantonRefreshNode}
          showHousesActivatedPassive={showHousesActivatedPassive}
        />


        {/* Отображение кабельных линий из БД */}       
        <CableShowDisplay
          showLines={showLines}
          showLines12={showLines12}
          showLines24={showLines24}
          showLines48={showLines48}
          showLines8={showLines8}
          showLines6={showLines6}
          showLines4={showLines4}
          showLines2={showLines2}
          showLines1={showLines1}
          showLines16={showLines16}
          showLines32={showLines32}
          showLines36={showLines36}
          showLines64={showLines64}
          showLines72={showLines72}
          showLines96={showLines96}
          showLines144={showLines144}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          statusModalTerritory={statusModalTerritory}
          descriptionOptic={descriptionOptic}
          openModalWithContent={openModalWithContent}
          showLinesTypeSolid={showLinesTypeSolid}
          showLinesTypeDashed={showLinesTypeDashed}
          onPolylineRef={handlePolylineRef} // Передаём функцию для получения рефов
          showLineDenomination={showLineDenomination}
          showPonLayer={showPonLayer}
          showKtvLayer={showKtvLayer}
          showEtherLayer={showEtherLayer}
          showLinesTypeBasement={showLinesTypeBasement}
          showLinesTypeFacade={showLinesTypeFacade}
          showLinesTypeLoft={showLinesTypeLoft}
          showLinesTypeRoof={showLinesTypeRoof}
          showLinesRankSummitToCanton={showLinesRankSummitToCanton}
          showAirBetweenHouses={showAirBetweenHouses}
          showAirPillars={showAirPillars}
        />

       
  
        {/*рисуем линк*/}
        <DrawingLineHandler 
          isLineDrawing={isLineDrawing} 
          color={selectedLineColor} 
          weight={selectedLineWidth} 
          setCoordinatesCableLine={setCoordinatesCableLine}
          cableKind={cableKind}
          linePoints={linePoints}
          setLinePoints={setLinePoints}
          removeLastPoint={removeLastPoint}
          updateLength={updateLength}
          switchesData={switchesData}
          selectedCanton={selectedCanton}
          selectedCity={selectedCity}
          setLengthCableSegment={setLengthCableSegment}   
          housesData={housesData}     
        />

{/* Редактирование линка Highway*/}
<FeatureGroup>
  {markerEditing === CONST_HIGHWAY && (
    <LinkEditingHighway
      polylinePoints={polylinePoints}
      setPolylinePoints={setPolylinePoints}
      editMode={linkEditing}
      setLengthCableEditing={setLengthCableEditing}
      setLineEditing={setLineEditing}
      selectedCity={selectedCity}
    />
  )}
</FeatureGroup>

{/* Редактирование линка Canton*/}
<FeatureGroup>
  {markerEditing === CONST_CANTON && (
    <LinkEditingCanton
      polylinePoints={polylinePoints}
      setPolylinePoints={setPolylinePoints}
      editMode={linkEditing}
      setLengthCableEditing={setLengthCableEditing}
      setLineEditing={setLineEditing}
      switchesData={switchesData}
      selectedCanton={selectedCanton}
      housesData={housesData}  
      polyline={polyline}
      setPolyline={setPolyline}
    /> 
  )}
</FeatureGroup>

       {/* Pillar в режиме редактирования */}
       <MarkerPoligonToClickDistance
        switchesData={switchesData} 
        marker={pillarMarker}
        markers={markersPillar}
        setMarkers={setPillarMarkers}
        coordinates={coordinatesPillar}
        setCoordinates={setCoordinatesPillar}
        selectedCanton={selectedCanton}
        housesData={housesData}
      />
       <MarkersEditing
         markers={markersPillar} 
         icon={iconPillar} 
         isLineDrawing={isLineDrawing} 
         removeMarker={removePillarMarker} 
         type={PILLAR_FLAG}
       />

       {/*Well в режиме редактирования */} 
       <MarkerPoligonToClickDistance
        switchesData={switchesData} 
        marker={manholeMarker}
        markers={markersManhole}
        setMarkers={setManholeMarkers}
        coordinates={coordinatesManhole}
        setCoordinates={setCoordinatesManhole}
        selectedCanton={selectedCanton}
        housesData={housesData}
      />
       <MarkersEditing 
          markers={markersManhole} 
          manholeMarker={manholeMarker}
          icon={iconManhole}
          isLineDrawing={isLineDrawing}
          removeMarker={removeManholeMarker} 
          type={WELL_FLAG}
      />
 
       {/*Coupling в режиме редактирования*/}
       <MarkerPoligonToClick
        switchesData={switchesData} 
        marker={couplingMarker}
        markers={markersCoupling}
        setMarkers={setCouplingMarkers}
        coordinates={coordinatesCoupling}
        setCoordinates={setCoordinatesCoupling}
        selectedCanton={selectedCanton}
        housesData={housesData}
      />
       <MarkersEditingCoupling 
         markers={markersCoupling}
         selectedRankCouling={selectedRankCouling}
         removeMarker={removeCouplingMarker}
         type={COUPLING_FLAG}
      />

         {/* Fob в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={fobMarker}
          markers={markersFob}
          setMarkers={setFobMarkers}
          coordinates={coordinatesFob}
          setCoordinates={setCoordinatesFob}
          selectedCanton={selectedCanton}
          housesData={housesData}
        />

       <MarkersEditingFob 
        markers={markersFob}
        selectedRankFob={selectedRankFob}
        removeMarker={removeFobMarker}
        type={FOB_FLAG}
      />

         {/* Pon-box в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={ponBoxMarker}
          markers={markersPonBox}
          setMarkers={setPonBoxMarkers}
          coordinates={coordinatesPonBox}
          setCoordinates={setCoordinatesPonBox}
          selectedCanton={selectedCanton}
          housesData={housesData}
        />

       <MarkersEditingPonBox
        markers={markersPonBox}
        removeMarker={removePonBoxMarker}
        type={PON_BOX_FLAG}
      />

      {/* PassiveNode в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={passiveNodeMarker}
          markers={markersPassiveNode}
          setMarkers={setPassiveNodeMarkers}
          coordinates={coordinatesPassiveNode}
          setCoordinates={setCoordinatesPassiveNode}
          selectedCanton={selectedCanton}
          housesData={housesData}
        />

       <MarkersEditingPassiveNode
        markers={markersPassiveNode}
        removeMarker={removePassiveNodeMarker}
        type={NODE_PASSIVE_FLAG}
      />

      {/* Отображение муфт */}
      <MarkersTwoIconViewingCoupling
        data={couplingLocationData}
        iconCoupling={iconCoupling}
        iconCouplingCanton={iconCouplingCanton}
        layersVisibilityCommunications={layersVisibilityCommunications.iconCoupling}
        isLineDrawing={isLineDrawing}
        flag={couplingMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_COUPLING}
        cantonFlag={CONST_CANTON_COUPLING}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        isComponentChangeCoor={isComponentСhangeCoorCoupling}
        setIsComponentChangeCoor={setIsComponentСhangeCoorCoupling}
        cantonRefresh={cantonCouplingRefresh}
        highwayRefresh={highwayCouplingRefresh}
        user={role.user}
        type={COUPLING}
      />     

      {/*  Отображение фобов */}
      <MarkersTwoIconViewingFob
        data={fobLocationData}
        iconCoupling={iconFob}
        iconCouplingCanton={iconFobCanton}
        layersVisibilityCommunications={layersVisibilityCommunications.iconFob}
        isLineDrawing={isLineDrawing}
        flag={fobMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_FOB}
        cantonFlag={CONST_CANTON_FOB}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        isComponentChangeCoor={isComponentСhangeCoorFob}
        setIsComponentChangeCoor={setIsComponentСhangeCoorFob}
        cantonRefresh={cantonFobRefresh}
        highwayRefresh={highwayFobRefresh}
        user={role.user}
        type={FOB}
      />     

      {/*  Отображение PassiveNode */}
      <MarkersPassiveNodeViewing
        data={passiveNodeLocationData}
        iconPassiveNode={iconPassiveNode}
        layersVisibilityCommunications={layersVisibilityCommunications.iconPassiveNode}
        isLineDrawing={isLineDrawing}
        flag={passiveNodeMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_PASSIVE_NODE}
        cantonFlag={CONST_CANTON_PASSIVE_NODE}   
        isComponentChangeCoor={isComponentChangeCoorPassiveNode}
        setIsComponentChangeCoor={setIsComponentChangeCoorPassiveNode}
        cantonRefresh={cantonPassiveNodeRefresh}
        highwayRefresh={highwayRefresh}
        user={role.user}
        type={PASSIVE_NODE}
      />     

      

      {/* Отображение опор */}
      <MarkersViewingPillar
        data={pillarData}
        icon={iconPillar}
        layersVisibilityCommunications={layersVisibilityCommunications.iconPillar}
        isLineDrawing={isLineDrawing}
        flag={pillarMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_PILLAR}
        cantonFlag={CONST_CANTON_PILLAR}
        position={position}
        type={PILLAR}
        user={role.user}
        cantonRefresh={cantonPillarRefresh}
        highwayRefresh={highwayPillarRefresh}
        isComponentChangeCoor={isComponentСhangeCoorPillar}
        setIsComponentChangeCoor={setIsComponentСhangeCoorPillar}
      />

       {/* Отображение Пон-бокс */}      
      <MarkersViewingPonBox
        data={ponBoxLocationData}
        icon={iconPonBox}
        layersVisibilityCommunications={layersVisibilityCommunications.iconPonBox}
        isLineDrawing={isLineDrawing}
        flag={ponBoxMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={'null'}
        cantonFlag={CONST_CANTON_PON_BOX}
        position={position}
        type={PON_BOX}
        user={role.user}
        cantonRefresh={cantonPonBoxRefresh}
        highwayRefresh={highwayRefresh}
        isComponentChangeCoor={isComponentСhangeCoorPonBox}
        setIsComponentChangeCoor={setIsComponentСhangeCoorPonBox}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        visibleNumberPonBox={visibleNumberPonBox}
      />

       {/* Отображение Делительй */}   
      <MarkersViewingDivider
        data={dividerData}
        icon={iconDividerUpc}
        layersVisibilityCommunications={layersVisibilityCommunications.iconDividerUpc}
        isLineDrawing={isLineDrawing}
        flag={ponBoxMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={'null'}
        cantonFlag={CONST_CANTON_PON_BOX}
        position={position}
        type={PON_BOX}
        user={role.user}
        cantonRefresh={cantonPonBoxRefresh}
        highwayRefresh={highwayRefresh}
        isComponentChangeCoor={isComponentСhangeCoorPonBox}
        setIsComponentChangeCoor={setIsComponentСhangeCoorPonBox}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
      />

      {/* Отображение проблемных мест на кабеле */} 
      <MarkersViewingProblemCable
        data={problemCableData}
        isLineDrawing={isLineDrawing}
        user={role.user}
        cantonCablaRefresh={cantonCablaRefresh}
        setMarkerProblemLineCoordinates={setMarkerProblemLineCoordinates}
        mapRef={mapRef}
        statusModalTerritory={statusModalTerritory}
        highwayRefresh={highwayRefresh}
      />

     {/* Отображение колодцев */}
     <MarkersViewing
       data={wellData}
       icon={iconManhole}
       layersVisibilityCommunications={layersVisibilityCommunications.iconManhole}
       isLineDrawing={isLineDrawing}
       flag={manholeMarker}
       openModalWithContent={openModalWithContent}
       statusModalTerritory={statusModalTerritory}
       highwayFlag={CONST_HIGHWAY_MANHOLE}
       cantonFlag={CONST_CANTON_MANHOLE}
       position={position}
       type={WELL}
       user={role.user}
       cantonRefresh={cantonWellRefresh}
       highwayRefresh={highwayWellRefresh}
       isComponentChangeCoor={isComponentСhangeCoor}
       setIsComponentChangeCoor={setIsComponentСhangeCoor}
      />
        {/* Отображение КТВ оптарей */}      
        <MarkersViewingOp
        data={ktvOpData}
        icon={iconOp}
        layersVisibilityCommunications={layersVisibilityCommunications.iconOp}
        isLineDrawing={isLineDrawing}       
        showKtvLayer={showKtvLayer}
       />

       {/* Отображение КТВ усилков */}      
       <MarkersViewingAmplifier
        data={ktvAmplifierData}
        icon={iconAmplifier}
        layersVisibilityCommunications={layersVisibilityCommunications.iconAmplifier}
        isLineDrawing={isLineDrawing}
        showKtvLayer={showKtvLayer}
       />

       

      

  </MapContainer>
</div>

      {/* Описание компонентов DialogDescription */}
      <DialogDescriptionComponent 
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpenModal={setOpenModal}
        content={modalContent} 
        markerType={markerType}
        isLineDrawing={isLineDrawing}
        manholeMarker={manholeMarker}
        pillarMarker={pillarMarker}
        couplingMarker={couplingMarker}
        fobMarker={fobMarker}
        ponBoxMarker={ponBoxMarker}
        role={role}
        user={role.user}
        changeLinkEditing={changeLinkEditing}
        linkEditing={linkEditing}
        highwayRefresh={highwayRefresh}
        cantonRefresh={cantonRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoor={setIsComponentСhangeCoor}
        cantonFobRefresh={cantonFobRefresh}
        cantonCouplingRefresh={cantonCouplingRefresh}
        cantonWellRefresh={cantonWellRefresh}
        cantonPillarRefresh={cantonPillarRefresh}
        cantonPonBoxRefresh={cantonPonBoxRefresh}
        cantonCablaRefresh={cantonCablaRefresh}
        setIsComponentСhangeCoorPillar={setIsComponentСhangeCoorPillar}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
        changeLinkEditingMarker={changeLinkEditingMarker}
        linkEditingProblem={linkEditingProblem}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
        passiveNodeMarker={passiveNodeMarker}
        cantonPassiveNodeRefresh={cantonPassiveNodeRefresh}
        setIsComponentChangeCoorPassiveNode={setIsComponentChangeCoorPassiveNode}
        highwayWellRefresh={highwayWellRefresh}
        highwayPillarRefresh={highwayPillarRefresh}
        highwayCouplingRefresh={highwayCouplingRefresh}
        highwayFobRefresh={highwayFobRefresh}
      />

      {/* Удаление компонента (Status=0) */}
      {/* <ModalDeleteComponent
        open={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        user={role.user}
        highwayTerritory={highwayTerritory}
        cantonTerritory={cantonTerritory}
        cantonRefresh={cantonRefresh}
        highwayRefresh={highwayRefresh}
        cantonFobRefresh={cantonFobRefresh}
        cantonCouplingRefresh={cantonCouplingRefresh}
        cantonWellRefresh={cantonWellRefresh}
        cantonPillarRefresh={cantonPillarRefresh}
        cantonPonBoxRefresh={cantonPonBoxRefresh}
        cantonCablaRefresh={cantonCablaRefresh}
      /> */}

      {/* Описание связей компонентов*/}
      <ModalDescriptionComponent
        open={openModalDescription}
        onClose={() => setOpenModalDescription(false)}
      />

        {/* Поиск компонентов*/}
        <ModalSearchComponentMap
        open={openModalSearch}
        onClose={() => setOpenModalSearch(false)}
        user={role.user}
      />

        {/* Косяки закрепов*/}
        <ModalFasteningErrors
        open={openFasteningErrors}
        onClose={() => setOpenModalFasteningErrors(false)}
        user={role.user}
        role={role.role}
      />

       {/* Маршрут кабеля*/}
       <ModalRouteCableMap
        open={openModalRouteCable}
        onClose={() => setOpenModalRouteCable(false)}
      />

       {/* Отображение Логов */}
       <ModalLog
          open={openModalLog}
          onClose={() => setOpenModalLog(false)}
          user={role.user}
        />
        
    </div>
  );
}

export default DrawingOpticsMap;
